/**
 * Match backend / dashboard logic: session active_platform first; avoid wrong default
 * when user has multiple linked accounts.
 */
export function resolveActivePlatform(userData) {
  if (!userData) return 'reddit';
  if (userData.active_platform) return userData.active_platform;
  if (userData.youtube_channel_title) return 'youtube';
  if (userData.facebook_name && !userData.reddit_username) return 'facebook';
  if (userData.reddit_username && !userData.facebook_name) return 'reddit';
  if (userData.facebook_name && (userData.platforms || []).includes('facebook')) return 'facebook';
  return userData.platforms?.[0] || 'reddit';
}

/** Facebook DYI ad-insights pages should only appear for Facebook sessions. */
export function platformSupportsAdInsights(platform) {
  return platform === 'facebook';
}
